import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error
    console.error('Error caught in ErrorBoundary:', error, errorInfo);

    // Optional: send error to a logging service
    // sendErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <h1 style={styles.title}>Something went wrong.</h1>
          <p style={styles.message}>
            Please refresh the page or contact support if the issue persists.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#f8f9fa',
    color: '#333',
    padding: '20px',
  },
  title: {
    fontSize: '24px',
    color: '#dc3545',
  },
  message: {
    fontSize: '16px',
    marginTop: '10px',
  },
};

export default ErrorBoundary;
